<script>
    import './main.sass'
    import { executeClient } from 'api/rage'
    import { translateText } from 'lang'
    import { fly } from 'svelte/transition';
    export let popupData;

    let title = popupData.title,
        text = popupData.text;
</script>

<div class="popup__newhud">
    {#if title.length > 0}
    <div class="popup__newhud_title">
        <span class="hud__icon-info popup__newhud_icon"/> {title}
    </div>
    {/if}
    <div class="popup__newhud_line"></div>
    
    {#if text.length > 0}
        <div class="popup__newhud_text" style="text-align: center">{@html text}</div>
        <div class="popup__newhud_line"></div>
    {/if}
    
    <div class="popup__newhud__many__buttons">
        <div class="popup__newhud_button" in:fly={{ y: 50, duration: 500 }} on:click={() => executeClient ('', 2)}>{translateText('popups', 'Вызвать EMS (6 мин)')}</div>
    </div>
</div>